const AudioMessage = ({
  id,
  url,
  replyId,
  time,
  getMessagePreviewById,
  name,
}) => {
  return (
    <div
      data-id={id}
      className='conv__body__body__inner__msgright__inner__bubble__voice flex flex-column'
    >
      {replyId && (
        <div
          // onClick={handleShowRepliedMessage}
          dir='auto'
          className='conv__body__body__inner__msgright__inner__bubble__replied_msg'
        >
          <span>{getMessagePreviewById(replyId)}</span>
        </div>
      )}
      <audio controls>
        <source src={url} type='audio/ogg' />
        <source src={url} type='audio/mpeg' />
        Your browser does not support the audio tag.
      </audio>
      <div className='flex conv__body__body__inner__msgright__inner__bubble__voice__time_status_wrapper'>
        <div className='conv__body__body__inner__msgright__inner__bubble__text__info__time'>
          {time} {'  '} {name}
        </div>
      </div>
    </div>
  );
};

export default AudioMessage;
